export const GET_DOWNTIME_CATEGORIES_REQUEST =
  'GET_DOWNTIME_CATEGORIES_REQUEST';
export const GET_DOWNTIME_CATEGORIES_SUCCESS =
  'GET_DOWNTIME_CATEGORIES_SUCCESS';
export const GET_DOWNTIME_CATEGORIES_ERROR = 'GET_DOWNTIME_CATEGORIES_ERROR';
